import Action from "@/action/Action"
import { applyService } from "@/service"
import { applicationState, fieldState, providerState, sessionState } from "@/state"
import DynamicProviderKey from "@/model/provider/DynamicProviderKey"

class SwitchProviderAction extends Action {
    #providerKey = null
    #applyMode = null

    constructor(providerKey, applyMode) {
        super()
        this.#providerKey = providerKey
        this.#applyMode = applyMode
    }

    async invoke() {
        const response = await applyService.startProvider(this.#providerKey, this.#applyMode)
        return await SwitchProviderAction.handleResponse(response)
    }

    static async handleResponse(response) {
        sessionState.dynamicProviderKey = new DynamicProviderKey(response.providerKey)
        applicationState.applyMode = response.applyMode
        fieldState.fields = response.fields
        fieldState.fieldGroupRules = response.fieldGroupRules
        providerState.providers = response.providers || []

        if (providerState.primaryProvider && response.providerKey === providerState.primaryProvider.providerKey) {
            applicationState.primaryLenderApplyMode = response.applyMode
        }

        // TODO: should we overwrite application data
    }
}

export default SwitchProviderAction
